import React from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "sf_learning_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    try {
      const existing = window.localStorage.getItem(COOKIE_KEY);
      setVisible(!existing);
    } catch (err) {
      setVisible(true);
    }
  }, []);

  const saveChoice = (choice) => {
    try {
      window.localStorage.setItem(
        COOKIE_KEY,
        JSON.stringify({ choice, accepted_at: new Date().toISOString() })
      );
    } catch (err) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] px-4 pb-4 sm:px-6" data-testid="cookie-consent-banner">
      <div className="mx-auto max-w-5xl rounded-3xl border border-emerald-100 bg-white p-4 shadow-2xl sm:p-5">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="text-sm text-gray-700">
            <p className="font-heading text-lg font-black text-black">Gestion des cookies</p>
            <p className="mt-1 max-w-3xl">
              SF Learning utilise des cookies nécessaires au fonctionnement du site et, selon ton choix,
              des cookies de mesure ou d’amélioration de l’expérience. Tu peux accepter ou refuser les cookies non essentiels.
              Consulte notre <Link to="/politique-confidentialite" className="font-semibold text-brand-green hover:underline">politique de confidentialité</Link>.
            </p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <button type="button" onClick={() => saveChoice("refused")} className="btn-ghost justify-center whitespace-nowrap">
              Refuser
            </button>
            <button type="button" onClick={() => saveChoice("accepted")} className="btn-primary justify-center whitespace-nowrap">
              Accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
